import React from "react";
import qs from "qs";
import debug from "debug";
import debug_ from "./debug";
import { initStorage } from "./tools/storage";
import LicenceBar from "./licence/LicenceBar";
import { getSessionToken, getDecodedSessionToken } from "./tools/monday";
import { isRetrospectiveTools } from "./tools";

if (process.env.NODE_ENV === "development") {
    debug.enable("*");

    // const whyDidYouRender = require('@welldone-software/why-did-you-render');
    // whyDidYouRender(React, {
    // //   trackAllPureComponents: true,
    //   include: [/BoardItem/],
    //   logOnDifferentValues: true
    // });
}

const log = debug_("index.js");

/* eslint-disable import/first */
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

import "./index.css";
import "monday-ui-react-core/dist/main.css";

const queryString = qs.parse(window.location.search, { ignoreQueryPrefix: true });
const view = queryString.kanbanalytics_view || process.env.REACT_APP_VIEW || "replay";
log(`using view: ${view}, from qs ${JSON.stringify(queryString)} or env var ${process.env.REACT_APP_VIEW}`);

const demo = queryString.demo_data || process.env.REACT_APP_DEMO_CONFIG || undefined;
// const demo = "demo_tree";
log(`using demo data: ${demo}, from qs ${JSON.stringify(queryString)} or env var ${process.env.REACT_APP_DEMO_CONFIG}`);

const configureRollbar = async () => {
    if (window.Rollbar) {
        const token = await getDecodedSessionToken();
        const payload = {
            environment: process.env.NODE_ENV,
            person: {
                id: token.dat.user_id
            },
            monday: {
                account_id: token.dat.account_id,
                slug: token.dat.slug,
                app_id: token.dat.app_id,
                client_id: token.dat.client_id,
                is_admin: token.dat.is_admin,
                install_id: token.dat.install_id
            }
        };

        window.Rollbar.configure({
            payload
        });
        return payload;
    }
};

configureRollbar().then((payload) =>
    log("Rollbar payload configured with session token data: " + JSON.stringify(payload))
);

initStorage({ monday: !demo });

log(`NODE_ENV: ${process.env.NODE_ENV}, REACT_APP_ENVIRONMENT: ${process.env.REACT_APP_ENVIRONMENT}`);

// production config
const licenceConfig = {
    licenceHost: "https://licence.omnitas.dev",
    appId: "funnels",
    // prod $29
    // stripePriceId: "price_1IEYcVCc9Vx8w0ESH3Qq0vtv",
    // prod $19
    stripePriceId: "price_1IEfAzCc9Vx8w0ESveQNaMXh",
    yearlyStripePriceId: "price_1IIyZiCc9Vx8w0ESG79pcRLp",
    publicKey: `-----BEGIN PUBLIC KEY-----MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAM2NF1FwRPWtanOD6v7sb0Mj37EN0e5az8m35oZALkldRFcoV8wKa9iSBjVR8CJRO6EHknX9vSOWAadh4349Iy8CAwEAAQ==-----END PUBLIC KEY-----`
};

// test config
if (process.env.NODE_ENV === "development") {
    licenceConfig.licenceHost = "https://test-licence.omnitas.dev";
    licenceConfig.stripePriceId = "price_1IEXkGCc9Vx8w0ESEszcdbYb";
    licenceConfig.yearlyStripePriceId = "price_1IIybYCc9Vx8w0ESK8vaMDyD";
} else if (process.env.REACT_APP_ENVIRONMENT === "staging") {
    licenceConfig.appId = "funnels-staging";
    licenceConfig.licenceHost = "https://test-licence.omnitas.dev";
    licenceConfig.stripePriceId = "price_1IEXkGCc9Vx8w0ESEszcdbYb";
    licenceConfig.yearlyStripePriceId = "price_1IIybYCc9Vx8w0ESK8vaMDyD";
}

ReactDOM.render(
    demo !== undefined || isRetrospectiveTools(view) ? (
        <App view={view} demo={demo} />
    ) : (
        <LicenceBar
            getMondaySessionToken={getSessionToken}
            appId={licenceConfig.appId}
            stripePriceId={licenceConfig.stripePriceId}
            yearlyStripePriceId={licenceConfig.yearlyStripePriceId}
            publicKey={licenceConfig.publicKey}
            licenceHost={licenceConfig.licenceHost}
        >
            <App view={view} />
        </LicenceBar>
    ),
    document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
